import React, { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import Button from '../../../base/ui/components/web/Button';
import { IconArrowLeft, IconArrowRight } from '../../../base/icons/svg';
import { useTranslation } from 'react-i18next';
import usePaging from './hooks/usePaging';
import { useDispatch, useSelector } from 'react-redux';
import { setVisibleRemoteParticipants } from '../../actions.any';
const useStyles = makeStyles()((theme) => {
    return {
        pagingTileView: {
            position: 'absolute',
            zIndex: 1,
            left: '8px',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            height: '64px',
            display: 'flex',
            justifyContent: 'space-between'
        },
        pagingBtn: {
            backgroundColor: '#606060',
            opacity: '0.35',
            transition: 'all 0.2s',
            '&:hover': {
                opacity: '1'
            },
            '& div > svg': {
                fill: theme.palette.black
            }
        },
        disableBtn: {
            opacity: 0,
            cursor: 'default',
            '&:hover': {
                opacity: 0
            },
        }
    };
});
const PagingTileView = () => {
    const { classes, cx } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { remoteParticipants, newParticipantJoinID, newParticipantLeaveID } = useSelector((state) => state['features/filmstrip']);
    const { currentPage, isShowNext, isShowPrev, handleNext, handlePrev, participantPage } = usePaging({ type: "Tileview" });
    useEffect(() => {
        if (!isShowNext && currentPage !== 0 && newParticipantJoinID) { // trang cuối
            dispatch(setVisibleRemoteParticipants(remoteParticipants.length - participantPage, remoteParticipants.length - 1));
        }
    }, [newParticipantJoinID]);
    useEffect(() => {
        if (!isShowNext && currentPage !== 0 && newParticipantLeaveID) { // trang cuối
            dispatch(setVisibleRemoteParticipants(remoteParticipants.length - participantPage, remoteParticipants.length - 1));
        }
    }, [newParticipantLeaveID]);
    return (React.createElement("div", { className: classes.pagingTileView },
        React.createElement(Button, { accessibilityLabel: t('paging.prev'), size: 'tiny', className: cx(classes.pagingBtn, !isShowPrev && classes.disableBtn), onClick: handlePrev, disabled: !isShowPrev, icon: IconArrowLeft }),
        React.createElement(Button, { accessibilityLabel: t('paging.next'), size: 'tiny', className: cx(classes.pagingBtn, !isShowNext && classes.disableBtn), onClick: handleNext, disabled: !isShowNext, icon: IconArrowRight })));
};
export default PagingTileView;
